import React from 'react'
import { fetchTokenVerification } from './verifyEmailAddressContainerActions'
import { connect } from 'react-redux'
import history from '../../core/history'
import VerifyEmailAddress from './VerifyEmailAddress'
import Spinner from '../../common/Spinners/Spinner'
import PropTypes from 'prop-types';

class VerifyEmailAddressContainer extends React.Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    token: PropTypes.string.isRequired,
    verifiedEmailAddress: PropTypes.string.isRequired,
    adviserName: PropTypes.string,
    adviserId: PropTypes.number,
    dispatch: PropTypes.func.isRequired,
    fetchTokenVerification: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)

    this.viewAdviser = this.viewAdviser.bind(this)
  }

  componentDidMount () {
    this.props.dispatch(this.props.fetchTokenVerification(this.props.token))
  }

  viewAdviser () {
    history.push(`/adviser/${encodeURIComponent(this.props.adviserName)}/${this.props.adviserId}/profile/view`)
  }

  render () {
    if (this.props.loading) {
      return <Spinner />
    }
    return (
      <VerifyEmailAddress
        verifiedEmailAddress={this.props.verifiedEmailAddress}
        adviserName={this.props.adviserName}
        viewAdviser={this.viewAdviser}
      />
    )
  }

}

const mapStateToProps = (state) => {
  return {
    adviserName: state.verifyEmailAddressContainer.adviserName,
    verifiedEmailAddress: state.verifyEmailAddressContainer.verifiedEmailAddress,
    adviserId: state.verifyEmailAddressContainer.adviserId,
    loading: state.verifyEmailAddressContainer.loading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTokenVerification: fetchTokenVerification,
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmailAddressContainer)
